// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useTokenStandardHoldings = () => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOffset({
    queryKey: ['queryTokenStandardHoldings'],
    queryFn: async (_, offset) => {
      return ledgerApi.queryTokenStandardHoldings(offset);
    },
  });
};

export default useTokenStandardHoldings;
